import { render, staticRenderFns } from "./ReqtrasladoAnalisisResumenComponent.vue?vue&type=template&id=16e41b1e&"
import script from "./ReqtrasladoAnalisisResumenComponent.vue?vue&type=script&lang=js&"
export * from "./ReqtrasladoAnalisisResumenComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports